module.exports = __webpack_public_path__ + "img/7-1.54f249b5.png";